import * as FILE_MANAGER_ACTIONS from '../redux/actions/file-manager-actions';

const state = {
    category: {},
    selectedItems: [],
    itemSelectedPopup: null
};

export default (previousState = state, { type, payload }) => {
    switch (type) {
        case FILE_MANAGER_ACTIONS.CHANGE_ITEM_SELECTED_POPUP:
            return {
                ...previousState,
                itemSelectedPopup: payload
            };
        case FILE_MANAGER_ACTIONS.CHANGE_CATEGORY:
            return {
                ...previousState,
                category: payload
            };
        case FILE_MANAGER_ACTIONS.CHANGE_SELECTED_ITEMS:
            return {
                ...previousState,
                selectedItems: payload
            };
        default:
            return previousState
    }
};
